import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import messages from '../messages';
import { ConfirmMoveMessage } from './confirm-move-message';
import { MAX_ALLOWED_NUMBER_OF_ORDERS } from '../constants/auto-batching-constants';
import { INVALID_NUMBER_OF_ORDERS, GENERAL_ERROR, ORDERS_INCLUDED_IN_OTHER_BATCH } from '../constants/error-states';
import { AutoBatchingContext } from '../context';
import style from '../style.module.less';

const ErrorDisplay = () => {
  const { errorState, totalRecords } = useContext(AutoBatchingContext);
  return (
    <BannerMessageV2
      bannerContainerClassName={style['banner-child-wrapper']}
      className={style['auto-batch-error']}
      content={
        <>
          {errorState === INVALID_NUMBER_OF_ORDERS && (
            <FormattedMessage
              {...messages.autoBatchingTotalExceeded}
              values={{
                totalAllowed: MAX_ALLOWED_NUMBER_OF_ORDERS,
                totalRecords,
                b: (chunks) => <span className={style['part-bold']}>{chunks}</span>,
              }}
            />
          )}
          {errorState === ORDERS_INCLUDED_IN_OTHER_BATCH && <ConfirmMoveMessage />}
          {errorState === GENERAL_ERROR && <FormattedMessage {...messages.autoBatchingErrorMessage} />}
        </>
      }
      status={BannerStatus.Warning}
    />
  );
};

export { ErrorDisplay };
